<div class="loading" *ngIf="showSpinner">
  <div class="loader">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="loading-text">
    <div style="display: flex;">
      <span class="loading-text-words"><strong style="font-weight: 700;">Ping</strong>fluence</span>
    </div>

  </div>
</div>
